import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { useEffect } from "react";
import { useGetNotificationListQuery } from "services/api/warehouseApi";
import { setNotificationList } from "store/Slices/gridEventSlice";
import { useAppDispatch } from "./StoreHooks";

const POLLING_INTERVAL_NOTIFICATION_LIST_MS = 50 * 6000;

export function useGetNotificationList(storeNb: number) {
  const dispatch = useAppDispatch();

  const {
    isLoading,
    data: fetchedNotifications,
    error,
  } = useGetNotificationListQuery(storeNb, {
    pollingInterval: POLLING_INTERVAL_NOTIFICATION_LIST_MS,
  });

  useEffect(() => {
    if (fetchedNotifications) {
      dispatch(setNotificationList(fetchedNotifications));
    }
  }, [fetchedNotifications, dispatch]);
  return { isLoading, error: error as FetchBaseQueryError };
}
